import { useEffect, useRef } from 'react';

interface LogoWatermarkProps {
  opacity?: number;
}

function LogoWatermark({ opacity = 0.14 }: LogoWatermarkProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    let rafId: number;

    const update = () => {
      if (!containerRef.current || !imgRef.current) {
        rafId = requestAnimationFrame(update);
        return;
      }
      const rect = containerRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
      const clampedProgress = Math.max(0, Math.min(1, progress));

      const offset = (clampedProgress - 0.5) * 80;

      imgRef.current.style.transform = `translate(-50%, calc(-50% + ${offset}px))`;

      rafId = requestAnimationFrame(update);
    };

    rafId = requestAnimationFrame(update);
    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <div
      ref={containerRef}
      aria-hidden="true"
      className="absolute inset-0 pointer-events-none overflow-hidden"
    >
      <img
        ref={imgRef}
        src="/images/LOGO-RAFAEL.webp"
        alt=""
        className="absolute top-1/2 left-1/2 w-[92vw] md:w-[1050px] lg:w-[1250px] max-w-none"
        style={{ opacity }}
        loading="lazy"
      />
    </div>
  );
}

export default LogoWatermark;